<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>
            小猪银行配置
            <clear-cache-apply />
            <sync-data />
          </span>

          <el-form :inline="true" class="demo-form-inline" style="margin: 30px 0px 0px 20px;">
            <el-form-item label="是否开放">
              <el-select v-model="moneyBasicConfig.is_open" style="width: 150px" placeholder="请选择">
                <el-option
                  v-for="item in openStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                v-model="moneyBasicConfig.startTime"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                v-model="moneyBasicConfig.endTime"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="开放等级">
              <el-input v-model.number="moneyBasicConfig.open_level" style="width: 100px;" placeholder="开放等级" />
            </el-form-item>
            <el-form-item label="资源路径">
              <el-input v-model.number="moneyBasicConfig.resource_dir " style="width: 300px;" placeholder="资源路径" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:pig:add']" type="primary" @click="basicOnSubmit">保存</el-button>
            </el-form-item>
          </el-form>

          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:pig:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <!--            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">-->
            <!--              <el-col :span="1.5">-->
            <!--                <el-upload-->
            <!--                  class="upload-demo"-->
            <!--                  :action="sys_app_logoAction"-->
            <!--                  accept="xlsx"-->
            <!--                  :limit="1"-->
            <!--                  :on-success="(res)=>{return importProbUploadSuccess(res)}"-->
            <!--                  :headers="headers"-->
            <!--                >-->
            <!--                  <el-button v-permisaction="['config:activityCoins:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>-->
            <!--                </el-upload>-->
            <!--              </el-col>-->

            <!--              <el-col :span="1.5">-->
            <!--                <el-button-->
            <!--                  v-permisaction="['config:activityCoins:export']"-->
            <!--                  type="primary"-->
            <!--                  icon="el-icon-download"-->
            <!--                  size="mini"-->
            <!--                  @click="exportData()"-->
            <!--                >导出</el-button>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form>
                        <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                          <el-form style="margin-top: 10px">
                            <el-form-item label="体力">
                              <el-card v-if="item.config.length > 0">
                                <el-form :inline="true">
                                  <el-row v-for="(p, pi) in item.config" :key="pi" style="margin-top: 10px;">
                                    <el-form-item label="类型">
                                      <el-select v-model.number="p.type" placeholder="请选择" @change="(v)=>{return typeChange(v, tabItem.label, scoreItem.group_name, true)}">
                                        <el-option
                                          v-for="item in types"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"
                                          :disabled="item.disabled"
                                        />
                                      </el-select>
                                    </el-form-item>
                                    <el-form-item label="落点体力">
                                      <el-input v-model.number="p.value" style="width: 100px;" placeholder="落点体力" />
                                    </el-form-item>
                                    <el-form-item label="经过的体力">
                                      <el-input v-model.number="p.pass_value" style="width: 100px;" placeholder="经过的体力" />
                                    </el-form-item>
                                    <el-form-item>
                                      <el-button type="danger" @click="delDay(tabItem.label,scoreItem.group_name, score_index, pi)">删除</el-button>
                                    </el-form-item>
                                  </el-row>
                                </el-form>
                              </el-card>
                              <el-form-item style="margin-top: 10px;">
                                <el-button type="primary" @click="addDay(tabItem.label,scoreItem.group_name, score_index)">+</el-button>
                              </el-form-item>
                            </el-form-item>
                            <el-form-item label="配置">
                              <el-card>
                                <el-form :inline="true">
                                  <el-row v-for="(p, pi) in item.reward" :key="pi" style="margin-top: 10px;">
                                    <el-form-item label="价格">
                                      <el-select v-model.number="p.price" placeholder="请选择" @change="(v)=>{return priceChange(v, tabItem.label, scoreItem.group_name, pi)}">
                                        <el-option
                                          v-for="item in shopSku"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"
                                        />
                                      </el-select>
                                    </el-form-item>
                                    <el-form-item label="冷却时间(天)">
                                      <el-input v-model.number="p.expiration" style="width: 100px;" placeholder="冷却时间(天)" />
                                    </el-form-item>
                                    <el-form-item label="体力上限值">
                                      <el-input v-model.number="p.maxSpin" style="width: 100px;" placeholder="体力上限值" />
                                    </el-form-item>
                                  </el-row>
                                </el-form>
                              </el-card>
                            </el-form-item>
                          </el-form>
                          <el-button v-permisaction="['config:pig:add']" type="primary" @click="onSubmit()">保存</el-button>
                          <el-button v-permisaction="['config:pig:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name ,item.id)">删除</el-button>
                        </el-row>
                        <el-button v-if="scoreItem.data.length <= 0" v-permisaction="['config:pig:add']" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import { getSku } from '@/api/config/shop-cfg'
import { updateBasicCfg, getBasicCfgList, delPigBasic } from '@/api/config/pig-cfg'
import { updateCommonCfg } from '@/api/config/common-cfg'
import { getToken } from '@/utils/auth'
import { exportActivityCoinCfg, importActivityCoinCfg } from '@/api/config/activity-coin-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'PigConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      taskType: [{
        label: '每日签到',
        value: 1
      }],
      moneyBasicConfig: {
        is_open: 0,
        open_level: 0,
        resource_dir: '',
        startTime: '',
        endTime: ''
      },
      activeName: 'first',
      disableType: [],
      shopSku: [],
      types: [
        { label: '起点', value: 16, disabled: false },
        { label: '热气球', value: 21, disabled: false },
        { label: '免费商店', value: 22, disabled: false },
        { label: '体力', value: 3, disabled: false },
        { label: '三格', value: 25, disabled: false }
      ],
      visibleArr: {},
      weekVisibleArr: {},
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 }
        // { label: '付费玩家', value: 2 }
      ],
      openStatus: [
        { label: '开启', value: 1 },
        { label: '关闭', value: 0 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      levelActiveName: '',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getGroup()
    this.getShopSkuList()
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    onSubmit(noTips = false) {
      // const data = JSON.stringify(this.formData)
      // console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          if (scoreItem.data[0].length < 1) {
            continue
          }

          postFormDataCondition[key] = condition

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]

          // console.log('days', _data.days)
          _data.stage = key
          _postData.push(_data)
        }
      }

      // console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log('_postData', _postData)
      updateBasicCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    getTables() {
      this.tabPane = []
      this.formData = []
      getBasicCfgList().then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.visibleArr, levelName, {})
            this.$set(this.weekVisibleArr, levelName, {})
            this.$set(this.disableType, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
            this.$set(this.visibleArr[levelName], scoreName, [])
            this.$set(this.weekVisibleArr[levelName], scoreName, [])
            this.$set(this.disableType[levelName], scoreName, [])
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })
          this.disableType[levelName][scoreName] = JSON.parse(JSON.stringify(this.types))
          for (const ii in data) {
            const _event = data[ii]
            if (_event.stage === i) {
              // this.visibleArr[levelName][scoreName].push({ visible: false }
              this.$set(this.formData[levelName][scoreName], 'data', [{
                id: _event.id,
                stage: _event.stage,
                reward: _event.reward,
                config: _event.config
              }])

              _event.config.forEach((item, index) => {
                this.listenType(levelName, scoreName)
              })
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }

          this.levelActiveName = levelName
        }

        if (Object.prototype.hasOwnProperty.call(res.data, 'basic')) {
          if (Object.prototype.hasOwnProperty.call(res.data.basic, 'is_open')) {
            this.moneyBasicConfig = res.data.basic
          }
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)

      // 修改弹窗
      const oldWeekVisle = this.weekVisibleArr[oldLevelName]
      Vue.delete(this.weekVisibleArr, oldLevelName)
      this.$set(this.weekVisibleArr, newLevelName, oldWeekVisle)

      // 修改弹窗
      const oldDisabled = this.disableType[oldLevelName]
      Vue.delete(this.disableType, oldLevelName)
      this.$set(this.disableType, newLevelName, oldDisabled)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        id: 0,
        stage: '',
        config: [],
        reward: [
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 },
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 },
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 }
        ]
      })
    },
    delEvent(levelName, scoreName, id) {
      console.log(id)
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPigBasic({ id: id }).then(res => {
            if (res.code === 200) {
              this.formData[levelName][scoreName].data = []
              this.onSubmit(true)
              this.getTables()
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
        this.$set(this.weekVisibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      this.weekVisibleArr[score.level_name][scoreTag].push({ visible: false })
      this.$set(this.disableType[score.level_name], scoreTag, JSON.parse(JSON.stringify(this.types)))
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        id: 0,
        stage: '',
        config: [],
        reward: [
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 },
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 },
          { price: this.shopSku[0].value, sku: this.shopSku[0].sku, expiration: 0, maxSpin: 0 }
        ]
      })

      this.listenType(score.level_name, scoreTag)
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      this.$set(this.weekVisibleArr, levelName, {})
      this.$set(this.disableType, levelName, {})
    },
    handleClick(tab, event) {
      console.log(tab.name)
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward.push(
        {
          price: 0, sku: '', expiration: 0, maxSpin: 0
        }
      )
    }, delReward(levelName, groupName, index, i, ri) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== ri
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.levelActiveName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)

      // 修改弹窗元素
      const oldWeekVisible = this.weekVisibleArr[levelName][oldGroupName]
      this.$delete(this.weekVisibleArr[levelName], oldGroupName)
      this.$set(this.weekVisibleArr[levelName], newGroupName, oldWeekVisible)

      const oldDisabled = this.disableType[levelName][oldGroupName]
      this.$delete(this.disableType[levelName], oldGroupName)
      this.$set(this.disableType[levelName], newGroupName, oldDisabled)
    },
    addDay(levelName, groupName, index) {
      this.listenType(levelName, groupName, true)
      let _selectType = 0
      for (const i in this.disableType[levelName][groupName]) {
        if (!this.disableType[levelName][groupName][i].disabled) {
          _selectType = this.disableType[levelName][groupName][i].value
          break
        }
      }

      if (_selectType < 1) {
        this.msgError('可选类型已达上限')
        return
      }
      this.formData[levelName][groupName].data[index].config.push(
        {
          type: parseInt(_selectType),
          pass_value: 0,
          value: 0
        }
      )

      this.listenType(levelName, groupName, true)
    },
    delDay(levelName, groupName, index, i) {
      const selectType = this.formData[levelName][groupName].data[index].config[i].type
      this.disableType[levelName][groupName].forEach((res, index) => {
        if (res.value === selectType) {
          this.disableType[levelName][groupName][index].disabled = false
        }
      })
      this.formData[levelName][groupName].data[index].config = this.formData[levelName][groupName].data[index].config.filter((item, key) => {
        return key !== i
      })
    }, listenType(levelName, groupName) {
      this.formData[levelName][groupName].data[0].config.forEach(item => {
        for (const i in this.disableType[levelName][groupName]) {
          const val = this.disableType[levelName][groupName][i]
          // console.log('type', item.type, val.value)
          if (val.value === item.type) {
            this.disableType[levelName][groupName][i].disabled = true
          }
        }
      })
    },
    typeChange(v, levelName, groupName) {
      for (const i in this.disableType[levelName][groupName]) {
        this.disableType[levelName][groupName][i].disabled = false
      }
      this.listenType(levelName, groupName)
    },
    getShopSkuList() {
      getSku().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopSku.push({ label: val.price, value: val.price, sku: val.sku })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, levelName, groupName, index) {
      let sku = ''
      this.shopSku.forEach(item => {
        if (v === item.value) {
          sku = item.sku
        }
      })

      this.formData[levelName][groupName].data[0].reward[index].sku = sku
    },
    basicOnSubmit() {
      if (!this.moneyBasicConfig.startTime) {
        this.msgError('开始时间不能为空')
        return
      }
      if (!this.moneyBasicConfig.endTime) {
        this.msgError('结束时间不能为空')
        return
      }
      if (this.moneyBasicConfig.startTime > this.moneyBasicConfig.endTime) {
        this.msgError('开始时间不能大于结束时间')
        return
      }
      if (this.moneyBasicConfig.resource_dir === '') {
        this.msgError('资源路径不能为空')
        return
      }

      const data = JSON.stringify(this.moneyBasicConfig)
      updateCommonCfg({ name: 'spinsPotCfg', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivityCoinCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      importActivityCoinCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
